import { render, staticRenderFns } from "./Rightshares.vue?vue&type=template&id=584476e9&"
import script from "./Rightshares.vue?vue&type=script&lang=js&"
export * from "./Rightshares.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports